export const typeOptions = [
  { value: "risc", label: "RISC Form", orderBy: "actualSurveyInspectionDatetime" },
  { value: "site-diary", label: "Site Diary", orderBy: "submissionDatetime" },
  { value: "safety", label: "Safety Inspection"},
  { value: "cleansing", label: "Cleansing Inspection"},
  { value: "labour", label: "Labour Return"},
  { value: "photo", label: "Photo", orderBy: "takenDatetime" },
];